import { Loader2, Mail, Phone, Send } from "lucide-react";
import { Input } from "./ui/input";
import { useState } from "react";
import { Textarea } from "./ui/textarea";
import { Button } from "./ui/button";
import z from "zod";

const contactSchema = z.object({
    name: z.string().trim().min(2, "Imię musi mieć minimum 2 znaki").max(100, "Imię jest za długie"),
    email: z.string().trim().email("Nieprawidłowy adres email").max(255, "Email jest za długi"),
    phone: z.string().trim().optional(),
    message: z.string().trim().min(10, "Wiadomość musi mieć minimum 10 znaków").max(2000, "Wiadomość jest za długa"),
})

const ContactSection = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: ""
    });

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        const validation = contactSchema.safeParse(formData);
        if(!validation.success) {
            return;
        }

        setIsLoading(true);

        try {
            // const res = await fetch("http://localhost:5000/api/contact", {
            //     method: "POST",
            //     headers: { "Content-Type": "application/json" },
            //     body: JSON.stringify(formData),
            // });

            // const txt = await res.text();
            setFormData({ name: "", email: "", phone: "", message: "" });
        } catch(err) {
            console.error('Error sending message', err);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <section id="kontakt" className="section-padding bg-background">
            <div className="container mx-auto">
                <div className="text-center max-w-2xl mx-auto mb-16">
                    <span className="inline-block text-primary font-medium tracking-widest uppercase text-sm mb-4">
                        Kontakt
                    </span>
                    <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6">
                        Skontaktuj się z nami
                    </h2>
                    <p className="text-muted-foreground text-lg">
                        Masz pytania lub chcesz zamówić wycenę? Napisz do nas!
                    </p>
                </div>

                {/* <div className="grid lg:grid-cols-2 gap-12 lg:gap-20"> */}
                <div className="flex gap-12 lg:gap-20 flex-col md:flex-row justify-center">
                    <div className="space-y-8">
                        <div className="flex items-start gap-4">
                            <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                                <Phone className="h-5 w-5 text-primary" />
                            </div>
                            <div>
                                <h3 className="font-semibold text-foreground mb-1">Telefon</h3>
                                <p className="text-muted-foreground"><a href="tel:+48728856850">+48 728 856 850</a><br />
                                <a href="tel:+48604726302">+48 604 726 302</a></p>
                            </div>
                        </div>
                    </div>
                    <div className="space-y-8">
                        <div className="flex items-start gap-4">
                            <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                                <Mail className="h-5 w-5 text-primary" />
                            </div>
                            <div>
                                <h3 className="font-semibold text-foreground mb-1">Email</h3>
                                <p className="text-muted-foreground"><a href="mailto:bmeble@poczta.fm">bmeble@poczta.fm</a></p>
                            </div>
                        </div>
                    </div>
                    {/* <div className="space-y-8">
                        <div className="flex items-start gap-4">
                            <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                                <Phone className="h-5 w-5 text-primary" />
                            </div>
                            <div>
                                <h3 className="font-semibold text-foreground mb-1">Telefon</h3>
                                <p className="text-muted-foreground"><a href="tel:+48728856850">+48 728 856 850</a><br />
                                <a href="tel:+48604726302">+48 604 726 302</a></p>
                            </div>
                        </div>

                        <div className="flex items-start gap-4">
                            <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                                <Mail className="h-5 w-5 text-primary" />
                            </div>
                            <div>
                                <h3 className="font-semibold text-foreground mb-1">Email</h3>
                                <p className="text-muted-foreground"><a href="mailto:bmeble@poczta.fm">bmeble@poczta.fm</a></p>
                            </div>
                        </div>
                    </div>
                    
                    <form className="space-y-6" onSubmit={handleSubmit}>
                        <div className="grid sm:grid-cols-2 gap-4">
                            <div>
                                <Input
                                    placeholder="Imię i nazwisko*"
                                    value={formData.name}
                                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                    required
                                    className="bg-card border-border/50 focus:border-primary text-foreground"
                                />
                            </div>
                            <div>
                                <Input
                                    type="email"
                                    placeholder="Email*"
                                    value={formData.email}
                                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                    required
                                    className="bg-card border-border/50 focus:border-primary text-foreground"
                                />
                            </div>
                        </div>

                        <Input 
                            type="tel"
                            placeholder="Telefon (opcjonalnie)"
                            value={formData.phone}
                            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                            className="bg-card border-border/50 focus:border-primary text-foreground"
                        />

                        <Textarea 
                            placeholder="Twoja wiadomość*"
                            value={formData.message}
                            onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                            className="bg-card border-border/50 focus:border-primary resize-none text-foreground"
                            required
                            rows={6}
                        />

                        <Button
                            type="submit"
                            size="lg"
                            // disabled={isLoading}
                            disabled
                            className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90"
                        >
                            {isLoading ? (
                                <>
                                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                                    Wysyłanie..
                                </>
                            ) : (
                                <>
                                    Wyślij wiadomość
                                    <Send className="ml-2 h-4 w-4" />
                                </>
                            )}
                        </Button>
                        <div className="text-center">
                            <span className="text-red-500/50 text-sm">
                                Formularz tymczasowo wyłączony, zapraszamy do innych sposobów kontaktu.
                            </span>
                        </div>
                    </form> */}
                </div>
            </div>
        </section>
    );
}

export default ContactSection;